import { render, staticRenderFns } from "./PromotionModal.vue?vue&type=template&id=150845cb&scoped=true"
import script from "./PromotionModal.vue?vue&type=script&lang=js"
export * from "./PromotionModal.vue?vue&type=script&lang=js"
import style0 from "./PromotionModal.vue?vue&type=style&index=0&id=150845cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150845cb",
  null
  
)

export default component.exports